import type { ContactPersonDto } from '@dhl/mdp-api'
import type { ContactPerson } from '~/common/model/contact'
import { convertToEmail } from '~/common/model/emails/conversions/convertToEmail'

export const convertToContactPerson = (contactPersonDto: ContactPersonDto | undefined): ContactPerson => {
  const { firstName = '', lastName = '', email = { address: '' }, phone = '' } = contactPersonDto || {}
  return {
    firstName,
    lastName,
    email: convertToEmail(email),
    phone,
  }
}
